import '@angular/common/locales/global/de';
import '@angular/common/locales/global/en';
import '@angular/common/locales/global/es';
import '@angular/common/locales/global/fr';
import '@angular/common/locales/global/it';

import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { trustedTypesPolicy } from './app/common/utils/helpers';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
} else {
  import('@apollo/client/dev').then(({ loadDevMessages, loadErrorMessages, loadErrorMessageHandler }) => {
    loadDevMessages();
    loadErrorMessageHandler();
    loadErrorMessages();
  });
}

const head = document.head;
const insertBefore = head.insertBefore;
head.insertBefore = <T extends Node>(newElement: T, referenceElement: Node): T => {
  if (
    newElement instanceof Element &&
    newElement?.hasAttribute('href') &&
    newElement?.getAttribute('href')?.includes('fonts.googleapis')
  ) {
    return newElement;
  }

  insertBefore.call(head, newElement, referenceElement);
  return newElement;
};

trustedTypesPolicy(window);

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
